import { Cup as CupIcon } from 'common/icons'
import { replaceNewLineEmojiAsElement } from 'common/variantsUtils'

type Props = {
  winnerVariant: string
  className?: string
}

const WinnerVariantInfo: React.FC<Props> = ({
  winnerVariant,
  className = '',
}: Props) => {
  return (
    <div className={`flex items-center gap-6 ${className}`}>
      <div className="flex justify-center items-center w-15 h-15 rounded-full bg-emerald-200">
        <CupIcon isDefaultColor={false} className="text-base-700" size={7} />
      </div>

      <div className="flex-grow text-base">
        <p className="text-maroon-400 font-bold">
          And the winner at the end of the test was...
        </p>
        <p className="text-coolGray-800 font-medium">
          {replaceNewLineEmojiAsElement(winnerVariant as string)}
        </p>
      </div>
    </div>
  )
}

export default WinnerVariantInfo
